module.exports = __webpack_public_path__ + "static/img/cabecera8.43ce3712.jpg";